export var OPTION_HEIGHT = 48;
export var OPTIONS_IN_DROPDOWN = 3;
export var EMPTY_OPTION = {
  icon: null,
  label: '',
  value: ''
};